export enum TipoAccionesEnum { ADD_TAG_TO_USER, ADD_USER_TO_CAMPAIGN, ADD_USER_TO_CHALLENGE, REMOVE_TAG_FROM_USER,
    REMOVE_USER_FROM_CAMPAIGN, REMOVE_USER_FROM_CHALLENGE }

const idTipoAcciones = new Map<TipoAccionesEnum, string>();
idTipoAcciones.set(TipoAccionesEnum.ADD_TAG_TO_USER, "ADD_TAG_TO_USER");
idTipoAcciones.set(TipoAccionesEnum.ADD_USER_TO_CAMPAIGN, "ADD_USER_TO_CAMPAIGN");
//idTipoAcciones.set(TipoAccionesEnum.ADD_USER_TO_CHALLENGE, "ADD_USER_TO_CHALLENGE");
idTipoAcciones.set(TipoAccionesEnum.REMOVE_TAG_FROM_USER, "REMOVE_TAG_FROM_USER");
idTipoAcciones.set(TipoAccionesEnum.REMOVE_USER_FROM_CAMPAIGN, "REMOVE_USER_FROM_CAMPAIGN");
//idTipoAcciones.set(TipoAccionesEnum.REMOVE_USER_FROM_CHALLENGE, "REMOVE_USER_FROM_CHALLENGE");
const nombresTipoAcciones = new Map<TipoAccionesEnum, string>();
nombresTipoAcciones.set(TipoAccionesEnum.ADD_TAG_TO_USER, "Agregar etiqueta al usuario");
nombresTipoAcciones.set(TipoAccionesEnum.ADD_USER_TO_CAMPAIGN, "Agregar usuario a grupo");
//nombresTipoAcciones.set(TipoAcciones.ADD_USER_TO_CHALLENGE, "ADD_USER_TO_CHALLENGE");
nombresTipoAcciones.set(TipoAccionesEnum.REMOVE_TAG_FROM_USER, "Eliminar etiqueta de usuario");
nombresTipoAcciones.set(TipoAccionesEnum.REMOVE_USER_FROM_CAMPAIGN, "Eliminar usuario de grupo");
//nombresTipoAcciones.set(TipoAcciones.REMOVE_USER_FROM_CHALLENGE, "REMOVE_USER_FROM_CHALLENGE");

export const obtenerIdTipoAccion: (accion: TipoAccionesEnum) => string = accion => idTipoAcciones.get(accion) ?? "";

export const obtenerNombreTipoAccion: (accion: TipoAccionesEnum) => string = accion => nombresTipoAcciones.get(accion) ?? "";
export const obtenerNombresTipoAccion: () => Array<[TipoAccionesEnum, string]> =
    () => Array.from(nombresTipoAcciones.entries());
